@if (control(); as control) {
  @if (field(); as field) {
    <mat-form-field fxFlex color="accent">
      @if (field.label?.(); as label) {
        <mat-label [ngClass]="{ 'capitalize-first-letter': $safeNavigationMigration(field.capitalized?.()) }">{{ label | translate }}</mat-label>
      }

      @if (field.multiple?.()) {
        <mat-select
          class="iot-platform-ui-form-field--{{ field.name?.() }} {{ field.inputCssClassName?.() }}"
          data-cy="form-control"
          [multiple]="true"
          [formControl]="control"
          [compareWith]="field.compareFn ?? defaultCompareFn"
          (selectionChange)="field.selectionChange?.($event)"
        >
          @if (field.selectTriggerRef?.()) {
            <mat-select-trigger>
              <ng-container
                [ngTemplateOutlet]="$safeNavigationMigration(field.selectTriggerRef?.())"
                [ngTemplateOutletContext]="{ item: $safeNavigationMigration(control?.getRawValue()) }"
              />
            </mat-select-trigger>
          }

          @for (item of field.items?.(); track trackByFn(item, $index)) {
            <mat-option
              [value]="item"
              [disabled]="field.isOptionDisabled ? field.isOptionDisabled(item) : $safeNavigationMigration(field.disabled?.())"
              class="iot-platform-ui-form-field--{{ field.name?.() }}-select-option {{ field.optionCssClassName?.() }}"
              data-cy="iot-platform-ui-form-field-select-option"
            >
              @if (field.selectDisplayWrapperRef?.()) {
                <ng-container [ngTemplateOutlet]="$safeNavigationMigration(field.selectDisplayWrapperRef?.())" [ngTemplateOutletContext]="{ item: item }" />
              } @else {
                {{ $safeNavigationMigration(field.displayBy?.(item)) | translate }}
              }
            </mat-option>
          }
        </mat-select>
      } @else {
        <mat-select
          class="iot-platform-ui-form-field--{{ field.name?.() }} {{ field.inputCssClassName?.() }}"
          data-cy="form-control"
          [formControl]="control"
          [compareWith]="field.compareFn ?? defaultCompareFn"
          (selectionChange)="field.selectionChange?.($event)"
        >
          @if (field.selectTriggerRef?.()) {
            <mat-select-trigger>
              <ng-container
                [ngTemplateOutlet]="$safeNavigationMigration(field.selectTriggerRef?.())"
                [ngTemplateOutletContext]="{ item: $safeNavigationMigration(control?.getRawValue()) }"
              />
            </mat-select-trigger>
          }

          @for (item of field.items?.(); track trackByFn(item, $index)) {
            <mat-option
              [value]="item"
              [disabled]="field.isOptionDisabled ? field.isOptionDisabled(item) : $safeNavigationMigration(field.disabled?.())"
              class="iot-platform-ui-form-field--{{ field.name?.() }}-select-option {{ field.optionCssClassName?.() }}"
              data-cy="iot-platform-ui-form-field-select-option"
            >
              @if (field.selectDisplayWrapperRef?.()) {
                <ng-container [ngTemplateOutlet]="$safeNavigationMigration(field.selectDisplayWrapperRef?.())" [ngTemplateOutletContext]="{ item: item }" />
              } @else {
                {{ $safeNavigationMigration(field.displayBy?.(item)) | translate }}
              }
            </mat-option>
          }
        </mat-select>
      }

      @if (control?.invalid && control?.hasError('required')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.REQUIRED' | translate }}</mat-error>
      } @else if (control?.invalid && control?.hasError('maxlength')) {
        <mat-error>{{
          'FORM.ERROR_MESSAGE.MAX_LENGTH' | translate: { value: $safeNavigationMigration(control.getError('maxlength')?.requiredLength) }
        }}</mat-error>
      } @else if (control?.invalid && control?.hasError('minlength')) {
        <mat-error>{{
          'FORM.ERROR_MESSAGE.MIN_LENGTH' | translate: { value: $safeNavigationMigration(control.getError('minlength')?.requiredLength) }
        }}</mat-error>
      } @else if (control?.invalid && control?.hasError('max')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.MAX' | translate: { value: $safeNavigationMigration(control.getError('max')?.max) } }}</mat-error>
      } @else if (control?.invalid && control?.hasError('min')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.MIN' | translate: { value: $safeNavigationMigration(control.getError('min')?.min) } }}</mat-error>
      } @else if (control?.invalid && control?.hasError('pattern')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.PATTERN' | translate }}</mat-error>
      } @else if (control?.invalid && (control?.hasError('duplicateName') || control?.hasError('nameExists'))) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.DUPLICATE_NAME' | translate }}</mat-error>
      } @else if (control?.invalid && control?.hasError('duplicateId')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.DUPLICATE_ID' | translate }}</mat-error>
      } @else if (control?.invalid && control?.hasError('link')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.LINK' | translate }}</mat-error>
      } @else if (control?.invalid && field.error?.enabled?.() && field.error?.message?.()) {
        <mat-error>{{ $safeNavigationMigration(field.error?.message?.()) | translate }}</mat-error>
      }

      @if (field.prefix) {
        <mat-icon
          class="prefix-icon cursor-pointer"
          [ngClass]="{ 'animate-spin': $safeNavigationMigration(field.prefix?.loading?.()), invisible: field.prefix?.visible && !field.prefix?.visible() }"
          style="margin-right: 5px"
          [matTooltip]="field.prefix?.tooltip?.() ?? '' | translate"
          matPrefix
          matTooltipClass="regular-tooltip"
          matTooltipPosition="below"
          (click)="field?.prefix?.onClick?.($event)"
          >{{ field.prefix?.icon?.() }}
        </mat-icon>
      }

      @if (field.showSpinner?.()) {
        <mat-spinner class="iot-platform-ui-form-field__dropdown-control_spinner" color="accent" diameter="16" mode="indeterminate" />
      }

      @if (field.suffix) {
        <mat-icon
          class="suffix-icon cursor-pointer"
          [ngClass]="{ 'animate-spin': $safeNavigationMigration(field.suffix?.loading?.()), invisible: field.suffix?.visible && !field.suffix?.visible() }"
          style="margin-left: 5px"
          [matTooltip]="field.suffix?.tooltip?.() ?? '' | translate"
          matSuffix
          matTooltipClass="regular-tooltip"
          matTooltipPosition="below"
          (click)="field?.suffix?.onClick?.($event)"
          >{{ field.suffix?.icon?.() }}
        </mat-icon>
      }

      @if (field.hint?.()?.type?.() === FormControlHintType.TEXT) {
        <mat-hint align="end">
          {{ $safeNavigationMigration(field.hint?.()?.text?.()) | translate }}
        </mat-hint>
      } @else if (field.hint?.()?.type?.() === FormControlHintType.MAX_LENGTH) {
        <mat-hint align="end"> {{ control?.getRawValue()?.length ?? 0 }} / {{ field.maxLength?.() }}</mat-hint>
      } @else if (field.hint?.()?.type?.() === FormControlHintType.TEMPLATE_REF) {
        <mat-hint align="end">
          <ng-container [ngTemplateOutlet]="$safeNavigationMigration(field.hint?.()?.templateRef?.())" />
        </mat-hint>
      }
    </mat-form-field>
  }
}
